'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NitroLoading = function NitroLoading(_ref) {
  var color = _ref.color,
      className = _ref.className,
      loadingButton = _ref.loadingButton,
      screen = _ref.screen,
      size = _ref.size,
      thickness = _ref.thickness;

  return _react2.default.createElement(
    _styles.LoadingWrapper,
    {
      className: className,
      fullScreen: screen,
      size: size
    },
    _react2.default.createElement(
      _styles.LoadingSpinner,
      {
        fullScreen: screen,
        isButton: loadingButton,
        size: size
      },
      _react2.default.createElement(
        _styles.LoadingSVG,
        {
          size: size,
          viewBox: '0 0 ' + size + ' ' + size
        },
        _react2.default.createElement(_styles.LoadingCircle, {
          cx: size / 2,
          cy: size / 2,
          r: (size - thickness) / 2,
          fill: 'none',
          strokeWidth: thickness,
          strokeMiterlimit: '20',
          color: color,
          isButton: loadingButton,
          size: size,
          thickness: thickness
        })
      )
    )
  );
};

NitroLoading.propTypes = {
  color: _propTypes2.default.string,
  className: _propTypes2.default.string,
  loadingButton: _propTypes2.default.bool,
  screen: _propTypes2.default.bool,
  size: _propTypes2.default.number,
  thickness: _propTypes2.default.number
};

NitroLoading.defaultProps = {
  size: 48,
  thickness: 3
};

exports.default = NitroLoading;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-loading/NitroLoading.js
// module id = 3013
// module chunks = 4